import { addValidationRule } from '@akihirotakamura/formsy-react'

addValidationRule('isFullWidth', (values, value) => {
  if (!value || value === '') return true
  return /^[^ -~｡-ﾟ]*$/.test(value)
})
